import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BaseUrlService {
  readonly baseUrlSetByInput = signal<string | undefined>(undefined);
}
